import React from "react"
import moment from "moment"
import { baseUrlImg } from "../../config/api"

const CreateGiftCardTicket = ({ arr, barcode }) => {
  const receipt = JSON.parse(arr?.receipt)

  return (
    <div className="json_spedizionepro">
      <div
        className="d-flex justify-content-center mb-4"
        style={{ border: "unset" }}
      >
        <img src={`${baseUrlImg}/${arr.logo}`} alt="service logo" height={50} />
      </div>

      <div style={{ paddingTop: 10 }}>
        <strong>Importo:</strong> <span>{receipt.balance || receipt.amount}</span>
      </div>
      {receipt.code && (
        <div style={{ paddingTop: 10 }}>
          <strong>Codice Voucher:</strong> <span>{receipt.code}</span>
        </div>
      )}

      {barcode && (
        <div style={{ paddingTop: 10 }}>
          <strong>Numero Seriale:</strong> <span>{barcode}</span>
        </div>
      )}

      {receipt?.cf && (
        <div style={{ paddingTop: 10 }}>
          <strong>Codice Fiscale:</strong> <span>{receipt.cf}</span>
        </div>
      )}

      <div style={{ paddingTop: 10 }}>
        <strong>Scadenza:</strong>{" "}
        <span>{moment(receipt.expires_at).format("DD/MM/YYYY HH:mm:ss")}</span>
      </div>
    </div>
  )
}

export default CreateGiftCardTicket
